export default [
    {
        "id": "YRML-143.1",
    },
    {
        "id": "YHDDJ-11.1",
    },
    {
        "id": "YSYJ-46.1",
    },
    {
        "id": "YSHL-2.1",
    },
    {
        "id": "YRML-207.1",

    },
    {
        "id": "YCYDL-294.1",
    },
    {
        "id": "YXYDL-544.1",

    },
    {
        "id": "YXYDL-525.1",

    },
    {
        "id": "YYHL-509.1",
    },
    {
        "id": "YNYL-91.2",

    },
    {
        "id": "YDFLEL-21.1",
    },
    {
        "id": "YFSYJ-2.1",
    },
    {
        "id": "HCH-3-1",

    },
    {
        "id": "HCH-3-0",

    },
    {
        "id": "HCH-3-3",
    },
    {
        "id": "HCH-3-2",
    },
    {
        "id": "YCYDL-304.1",

    },
    {
        "id": "YNYL-57.1",
    },
    {
        "id": "YAMZL-9.1",
    },
    {
        "id": "YAMZL-8.1",
    },
    {
        "id": "YCYDL-281.1",
    },
    {
        "id": "YXYDL-534.1",
    },
    {
        "id": "YYHL-475.1",
    },
    {
        "id": "YRML-259.1",
    },
    {
        "id": "YJSCL-34.1",
    }
]